var capitaliseStr = function capitaliseStr(str) {
  if (!str) {
    return '';
  }
  for (var i = 1; i < str.length + 1; i++) {
    if (str[i - 1].toLowerCase() !== str[i - 1].toUpperCase()) {
      return str.slice(0, i).toUpperCase() + str.slice(i).toLowerCase();
    }
  }
  return str;
};
var insertSpacesInStr = function insertSpacesInStr(str, interval) {
  var reversedArray = str.split('').reverse();
  if (interval <= 0) {
    return str;
  }
  for (var i = interval; i < reversedArray.length; i += interval) {
    reversedArray.splice(i, 0, ' ');
    // noinspection AssignmentToForLoopParameterJS
    i++;
  }
  return reversedArray.reverse().join('');
};
var getShortStr = function getShortStr(str, charLim) {
  return charLim > 2 && str.length > charLim ? "".concat(str.slice(0, charLim - 3), "...") : str;
};
var getHashCode = function getHashCode(s) {
  return s.split('').reduce(function (a, b) {
    var c = (a << 5) - a + b.charCodeAt(0);
    return c & c;
  }, 0);
};

export { capitaliseStr, getHashCode, getShortStr, insertSpacesInStr };
